import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    paddingBottom: '20px',
    width: '500px',
    margin: '0 auto'
  },
  dense: {
    marginTop: theme.spacing(2)
  },
  menu: {
    width: 200
  }
}));

export default function AutoSizeInput(props) {
  const classes = useStyles();
  return (
    <TextField
      id="outlined-multiline-static"
      label={props.label}
      multiline
      rows={props.rows}
      defaultValue={props.defaultValue}
      className={classes.textField}
      margin="normal"
      variant="outlined"
      name={props.name}
      onChange={props.onChange}
    />
  );
}
